import useCustomTranslation from "@/hooks/useTranslation";
import React from "react";
const UniversalComp: React.FC = () => {
	const { t } = useCustomTranslation();
	return (
		<div
			className="pageView"
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "480px",
				color: "white",
				position: "relative",
				fontSize: "16px",
			}}
		>
			<h1>{t("NoPermission")}...</h1>
		</div>
	);
};

export default UniversalComp;
